export const footColumns = [
  {
    title: "Job Number",
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Site",
    width: { wch: 40 },
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Service Date",
    width: { wch: 25 },
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Service Type",
    width: { wch: 25 },
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "EWC Code",
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Cost",
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Provider",
    width: { wch: 25 },
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
  {
    title: "Co2 Emmissions",
    width: { wch: 25 },
    style: {
      font: { sz: "10", bold: true },
      fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
    },
  },
];

export const otherColumns = [
    {
      title: "Job Number",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Site",
      width: { wch: 40 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Service Date",
      width: { wch: 25 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Service Type",
      width: { wch: 25 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "EWC Code",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Cost",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Provider",
      width: { wch: 25 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "WTN Number",
      width: { wch: 25 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Disposal Site",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Tonnage",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Diverted Tonnage",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Volumn",
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
    {
      title: "Landfill Diversion Rate",
      width: { wch: 30 },
      style: {
        font: { sz: "10", bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "52a9dd" } },
      },
    },
  ];
